import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  container: {
    minWidth: '50%'

  },
  drawerPaper: {
    width: '70%',
    alignItems: 'center',
    padding: '40px 80px',
    scrollWidth: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0
    }
  },
})

class ContentDrawer extends React.Component {

  render () {
    let {
      classes,
      children,
      onClose,
      open
    } = this.props

    return <Drawer open={open} className={classes.container} onClose={onClose}
                   classes={{ paper: classes.drawerPaper }}
    >
      {children}
    </Drawer>
  }

}

export default withStyles(styles)(ContentDrawer)
